import React from 'react';
// portr sdk
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
// libs
import * as AmCharts from 'ammap3';
import * as WorldLow from 'ammap3/ammap/maps/js/worldLow';
import * as Theme from 'ammap3/ammap/themes/light';
// models
import IFlightDetails from '../../models/flight-details.interface';
import ITrackingDetails from '../../models/tracking-details.interface';

// styles
const styles = require('./flight-map.scss');

interface IProps {
  flightDetails: IFlightDetails;
  trackingBookingDetails: ITrackingDetails;
}

interface IState {
  flightDetails: IFlightDetails;
  trackingDetails: ITrackingDetails;
}

class FlightMapComponent extends React.Component<IProps, IState> {

  public bookingProductService = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      flightDetails: props.flightDetails,
      trackingDetails: props.trackingBookingDetails
    }
    console.log(AmCharts, WorldLow, Theme);
  }

  componentDidMount() {
    const markerData = portrSDK.getFlightMapMarkers(this.state.flightDetails.flightStops);

    if (markerData.itemArray.length > 0) {
      portrSDK.getFlightMap({
        latitudes: markerData.latitudeHolder,
        longitudes: markerData.longitudeHolder,
        mapMarkers: markerData.itemArray
      });
    }
  }

  public render() {

    return(
      <div>
        <div id='map' className={styles.map}></div>
      </div>
    );

  };

}

export default FlightMapComponent;




// WEBPACK FOOTER //
// ./src/components/flight-map/flight-map.component.tsx